module.exports = __webpack_public_path__ + "static/greenery-02-d1d9dc1a600e4961be11182fa312d7c3.jpg";